import React from 'react';
import Fireicon from '../../assets/FireIcon.png';

interface GasBurnDisplayProps {
  gasBurnValue: number;
}


const formatNumber = (value: number): string => {
  if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + 'M';
  if (value >= 1_000) return (value / 1_000).toFixed(1) + 'K';
  return value.toLocaleString();
};

const GasBurnDisplay: React.FC<GasBurnDisplayProps> = ({ gasBurnValue }) => {
  const numericValue = Number(gasBurnValue);
  if (!numericValue) return null;
  
  return (
    <div className="w-1/2 flex flex-col items-center space-y-3 mt-4">
      {/* Fire Icon */}
      <div className="flex justify-center items-center mt-4">
        <img src={Fireicon} alt="Fire Icon" className="w-6 h-6" />
      </div>

      {/* Gas Burn Value */}
      <div className="flex justify-center items-center mb-2">
        <span className="text-2xl font-semibold">{formatNumber(gasBurnValue)}</span>
      </div>

      {/* GasBurn Title */}
      <div className="flex justify-center items-center">
        <h4 className="text-md text-gray-600">GasBurn</h4>
      </div>
    </div>
  );
};

export default GasBurnDisplay;
